export enum ExceptionEnum {
  // page not access
  PAGE_NOT_ACCESS = 403,
  // page not found
  PAGE_NOT_FOUND = 404,
}